<template>
    <div>
        <h1>订单金额明细</h1>
        <el-table :data="setData" border style="width: 100%">
            <!-- <el-table-column type="index" label="行号" width="70" :index="indexMethod">
            </el-table-column> -->
            <el-table-column prop="product_total" label="商品总价" align="center">
            </el-table-column>
            <el-table-column prop="freight_total" label="运费" align="center">
            </el-table-column>
            <el-table-column prop="process_cost" label="工艺加工" align="center">
            </el-table-column>
            <el-table-column prop="credit_discount" label="积分优惠" align="center">
            </el-table-column>
            <el-table-column prop="differ_price_total" label="补差金额" align="center">
            </el-table-column>
            <el-table-column prop="ture_total" label="合计总金额" align="center">
            </el-table-column>
            <el-table-column fixed="right" label="查看支付凭证" align="center">
                <template>
                    <el-button type="success" @click="invoiceS()">查看</el-button>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="查看合同凭证" align="center">
                <template>
                    <el-button type="success" @click="contract()">查看合同</el-button>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="查看交易流水" align="center" v-if="newData&&newData.payment == '工行e企付'">
                <template>
                    <el-button type="success" @click="serialNumber()">查看交易流水</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column fixed="right" label="导出销售单" align="center">
                <template>
                    <el-button type="success" @click="salesSlip()">导出销售单</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-dialog v-dialogDrag  title="" @close='closeDialog' :visible.sync="dialogTableVisiblearr" width='65%' :modal-append-to-body=false>
            <div v-for="(item, index) in imgo[0]" :key="index">
                <div>
                    <h3>点击查看</h3>
                    <br />
                    <a :href="item" target="_blank" rel="noopener noreferrer">{{ item }}</a>
                    <br />
                    <br />
                    <iframe style="width: 100%; height: 500px" :src="item" frameborder="0">{{ item }}</iframe>
              </div>
            </div>
        </el-dialog>
        <el-dialog v-dialogDrag  title="" @close='closeDialog' :visible.sync="dialogTableVisible" width='75%' :modal-append-to-body=false>
            <div v-for="(i ,index) in imgo" :key="index">
                <img :src="i.pay_image"/>
            </div>
        </el-dialog>
        <!-- 支付流水 -->
        <el-dialog v-dialogDrag  title="" @close='closeDialog' :visible.sync="dialogTableVisiblearrs" width='65%' :modal-append-to-body=false>
            <div style="margin: 20px;" v-for="(item,index) in list" :key="index" class="descriptions">
            <el-descriptions
                direction="horizontal"
                :column="2"
                border
            >
                <el-descriptions-item label="支付金额" label-align="center">{{item.RechargeMoney}}</el-descriptions-item>
                <el-descriptions-item label="交易流水号" label-align="center">{{item.RechargeOrderNumber}}</el-descriptions-item>
                <el-descriptions-item label="开始时间" label-align="center">{{item.CreateTime}}</el-descriptions-item>
                <el-descriptions-item label="订单状态" label-align="center">{{item.status}}</el-descriptions-item>
                <el-descriptions-item v-if="item.banks.length > 0" label="交易银行" label-align="center">{{item.banks.bankName}}</el-descriptions-item>
                <el-descriptions-item v-if="item.banks.length > 0" label="银行账户" label-align="center">{{item.banks.Account}}</el-descriptions-item>
                <el-descriptions-item v-if="item.banks.length > 0" label="公司名称" label-align="center">{{item.banks.AccountName}}</el-descriptions-item>
            </el-descriptions>
        </div>
        </el-dialog>
    </div>
</template>
<script>
    import {payorder, backstage, saleordercontract,downloadorderinfo,spotsale,getOrderRecharge} from '../../../static/API/API.js'
export default {
    props:['seta','newData'],
    data() {
        return {
            dialogTableVisible:false,
            dialogTableVisiblearr:false,
            dialogTableVisiblearrs:false,
            tip:false,
            setData:[],
            setas:this.seta,
            imgo:[],
            companyid:'0',
            list:[]
        }
    },
    watch:{
        seta(val){
            this.setas = val
            this.detailSum()
        },
        setas(val){
           this.$emit('seta',val)
        },
    },
    mounted(){
        this.companyid = sessionStorage.getItem('companyid')
      this.detailSum()
    },
    methods: {
        detailSum(){
            this.setas = this.seta
            let params = new URLSearchParams();
            params.append('head_id', this.setas);
            this.$axios.get(backstage,{
                params
            }).then(res =>{
                this.setData  = res.data
            })
            },
     //关闭弹框的事件
      closeDialog() {
        this.tip = true;
      },
    //查看支付凭证
      invoiceS() {
        this.setas = this.seta
        let params = new URLSearchParams()
        params.append('order_num',this.setas)
        this.$axios.get(payorder,{
            params
        }).then(res =>{
            if(res.data == ''){
                alert('暂无图片')
            }else{
                this.imgo = res.data
                this.dialogTableVisible = true;
            }
        })
      },
      //查看合同
      contract(){
        this.imgo = []
        let params = new URLSearchParams()
        params.append('order_id',this.setas)
        this.$axios.get(saleordercontract,{
            params
        }).then(res =>{
            if(res.data.datas == false || res.data.datas.length < 0 || res.data.datas[0].link == ''){
                this.$message({
                    message: '暂无合同',
                    type: 'warning',
                    duration:1000,
                    showClose: true,
        });
            }else{
              this.imgo.push(res.data.datas[0].link.split(','))
              this.dialogTableVisiblearr = true;
            }
        })
      },
      serialNumber(){
        let params = new URLSearchParams()
        params.append('head_id',this.setas)
        this.$axios.get(getOrderRecharge,{params}).then(res =>{
            this.list = res.data
            this.dialogTableVisiblearrs = true
        })
      },
        //自动生成行号
        indexMethod(index) {
            return index + 1;
        },
        // 导出销售单
        salesSlip(){
            console.log(this.form,'1231');
            if(this.form.is_check == '已审核' && this.form.status == null){
                 let params = new URLSearchParams()
                params.append('sale_id',this.setas)
                this.$axios.get(downloadorderinfo,{
                    params
                }).then(res =>{
                    window.open(res.data)
                })
            }else{
                this.$message({
                   message: '该订单不能导出',
                   type: 'warning'
                });
        //         let params = new URLSearchParams();
        //         params.append('ope_type', '单头明细');
        //         params.append('head_id', this.form.SAL_SALE_HEAD_id_PK);
        //         params.append('companyid', this.companyid);
        //         this.$axios.get(spotsale, {
        //             params
        //         }).then(res => {
        //             console.log(res);
        //             this.showorder = res.data
        //             res.data.forEach(e => {
        //             if (e.is_delivery != '已出库' && e.is_delivery != '待出库') {
                       
        //             } else {
        //                 this.dlogTable = true
        //                 this.$message({
        //                 message: '该订单不能打印',
        //                 type: 'warning'
        //         });
        //             }
        //             })
        //   });
            }
        }
    }
}
</script>
<style scoped>
    h1{
        margin-top: 20px;
    }
    a:link{
      text-decoration:underline;   /* 指正常的未被访问过的链接*/ 
    }
    a:hover{
      color: #3861AB;
    }
</style>


// WEBPACK FOOTER //
// src/views/public/vouCher.vue